import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=22827d7c&scoped=true"
import script from "./CmsContent.vue?vue&type=script&lang=ts"
export * from "./CmsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22827d7c",
  null
  
)

export default component.exports